<template lang="pug">
    .chat-login-failed-page
        slot
</template>

<script>
export default {
    name: 'blank-layout',
}
</script>

<style lang="scss">
.chat-login-failed-page {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>